var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.channel || _vm.offline)?_c('task-list',{attrs:{"id":"mobile-checklist","ticket":_vm.ticket,"channel":_vm.channel,"service":_vm.apiService}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }